import { SensorsList } from "../../../../../src/monitoring/SensorsList";
import * as React from 'react';
export default {
  SensorsList,
  React
};